import { Link } from "react-router-dom";
import { MapPinIcon } from "@heroicons/react/24/outline";

import { Job } from "services/jobs";
import { toPlainText } from "./Description";

type JobCardProps = {
  job: Job;
};

const EXCERPT_LENGTH = 220;

const JobCard = ({ job }: JobCardProps) => {
  const { description, department, jobLocation, jobTitle, jobType } =
    job.details;
  const text = toPlainText(description ?? "").replace(/\s+/g, " ").trim();
  const excerpt =
    text.length > EXCERPT_LENGTH ? `${text.slice(0, EXCERPT_LENGTH)}…` : text;

  return (
    <li>
      <Link
        to={`/job/${encodeURIComponent(job.system.id)}`}
        className="flex flex-col gap-2 rounded-xl p-4 hover:bg-orange-50 focus:bg-orange-50 focus:outline-none"
      >
        <h2 className="text-xl font-semibold text-gray-900 sm:text-2xl">
          {jobTitle}
        </h2>
        <div className="flex flex-wrap items-center gap-2 text-sm text-gray-600">
          {jobLocation && (
            <span className="flex items-center gap-1 rounded-2xl border px-3 py-1">
              <MapPinIcon className="h-3 w-3" aria-hidden="true" />
              {jobLocation}
            </span>
          )}
          {jobType && <span className="rounded-2xl border px-3 py-1">{jobType}</span>}
          {department && (
            <span className="rounded-2xl border px-3 py-1">{department}</span>
          )}
        </div>
        {excerpt && <p className="text-sm text-gray-600">{excerpt}</p>}
      </Link>
    </li>
  );
};

export default JobCard;
